module.exports = __webpack_public_path__ + "static/media/A16.37e18405.jpg";